import React, {useState, useEffect} from 'react';
import {Card, Row, Col, Button} from 'react-bootstrap';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import NavBar from './navBar';
import SiderBarPro from '../components/siderBarPro';
import { dailyReviews, overallReviews } from '../services/dashboardServices';
import {FaChartLine, FaChartBar, FaBars, FaCoins, FaMoneyBill} from 'react-icons/fa'
import { styles } from '../redux/slices/styleSlice';
import { useSelector } from 'react-redux';


const Dashboard = () => {
   const myStyle = useSelector(state => state.style.payload);
   useEffect(() => {
    console.log(myStyle.marginLeft);
   })
   console.log(myStyle.marginLeft);
  return (
   
<div className='mt-2 m-0 pt-4'>
{/* <div className='col-lg-2 col-sm-2 col-xs-2' >
<MySidebar/>
</div> */}
{/* <MySidebar/> */}

<div id='' className='position-relative top-0 end-0  '
style={{  }}
>
{/* <h1 className='ms-5'> Dashboard </h1> */}
    <div className=''>
        <h2 className='text-center'> Daily Reviews (Today's Review) </h2>

            <Row xs={1} md={2} sm={2} lg='4' className="g-2 m-2">
                {dailyReviews.map((daily, idx) => (
                    <Col>
                    <Card className='m' >
                        <Button variant='light' className='text-start d-flex' style={{ }}> 
                            
                            <Card.Body>
                            <Card.Title> 
                                <h6>
                                {
                                daily.icon === 'trans' && <FaChartLine size='30' /> 
                                }
                                {
                                daily.icon === 'sales' && <FaChartBar size='30' />
                                }
                                {
                                daily.icon === 'sProfit' && <FaMoneyBill size='30' /> 
                                }
                                {
                                daily.icon === 'fProfit' && <FaCoins size='30' />
                                }

                               <b> {` ${daily.title}`} </b>
                               </h6> 
                            </Card.Title>
                            <Card.Text className='m-0'>
                                <small>
                                    {daily.amount ? `amount: $${daily.amount}` : (`successful: ${daily.successful }`)}<br/>
                                    {  daily.failed &&
                                    ( `failed: ${daily.failed}`)}
                                </small>
                            </Card.Text>
                            </Card.Body>
                        </Button>
                        
                    </Card>
                    </Col>
                ))}
            </Row>
    </div>

    <div>
        <h2 className='text-center'> Overall Summary (All Time Total) </h2>

            <Row xs={1} md={3} sm={2} className="g-2 m-2 mt-0">
                {overallReviews.map((overall, idx) => (
                    <Col>
                    <Card>
                        <Button variant='outline-dark'  style={{ height: '180px' }}>
                            <Card.Img variant="top" src="holder.js/100px160" height='80px' />
                            <Card.Body>
                            <Card.Title> {overall.title}</Card.Title>
                            <Card.Text style={{ height:'10%' }}>
                                <small> 
                                    {overall.amount ? overall.amount : (`successful: ${overall.successful }`)}<br/>
                                    {  overall.failed &&
                                    ( `failed: ${overall.failed}`)}
                                </small>
                            </Card.Text>
                            </Card.Body>
                        </Button>
                        
                    </Card>
                    </Col>
                ))}
            </Row>
    </div>
</div>
</div>

  )
}

export default Dashboard